import React, {useEffect, useState} from 'react';
import {Card} from "primereact/card";
import {Dropdown} from "primereact/dropdown";
import "react-quill/dist/quill.snow.css";
import {depots} from "../../../utils/helper";
import HumanCreateForm from "./HumanCreateForm/HumanCreateForm";
import AnimalCreateForm from "./AnimalCreateForm/AnimalCreateForm";
import HerbalCreateForm from "./HerbalCreateForm/HerbalCreateForm";
import CropCreateForm from "./CropCreateForm/CropCreateForm";
import AgroCreateForm from "./AgroCreateForm/AgroCreateForm";
import GardenCreateForm from "./GardenCreateForm/GardenCreateForm";
import PetCreateForm from "./PetCreateForm/PetCreateForm";
import {useSearchParams} from "react-router-dom";

const NewProduct = () => {
    const [params,setParams]:any = useSearchParams();
    const [selectedDepot,setSelectedDepot] = useState({name:"Select a division",code:null});

    const form = Number(selectedDepot.code) === 8 ? <HumanCreateForm/> : Number(selectedDepot.code) === 9 ? <AnimalCreateForm/> : Number(selectedDepot.code) === 10 ? <HerbalCreateForm/> : Number(selectedDepot.code) === 11 ? <CropCreateForm/> : Number(selectedDepot.code) === 12 ? <AgroCreateForm/> : Number(selectedDepot.code) === 14 ? <GardenCreateForm/> : Number(selectedDepot.code) === 13 ?<PetCreateForm/> : null;

    const header = (
        <div className='flex align-items-center justify-content-between p-4 pb-0'>
            <h4 className="m-0">New Product || {selectedDepot.name}</h4>
            <div>
                <Dropdown
                    showClear={selectedDepot.code !== null}
                    value={selectedDepot.code ? selectedDepot : null}
                    onChange={(e) => {
                        const value = e.value;
                        setSelectedDepot(value || {name: 'Select Division', code: null});
                        const newParams = new URLSearchParams(window.location.search);
                        if (value?.code) {
                            newParams.set("division", value.code);
                        } else {
                            newParams.delete("division");
                        }
                        setParams(newParams);
                    }}
                    options={depots}
                    optionLabel="name"
                    placeholder={"Select a Category"}
                    className="w-full md:w-14rem mr-2"
                />
            </div>
        </div>
    )

    useEffect(() => {
        const setDefaultCategory = ()=>{
            const code = params.get('division');
            if (code) {
                const matched:any = depots.find((o:any) => Number(o.code) === Number(code));
                if (matched) setSelectedDepot(matched);
            }
        }
        setDefaultCategory()
    }, [params]);

    return (
        <Card header={header}>
            {form}
        </Card>
    );
};

export default NewProduct;